const customAddToCart = async function (event, preorderDate, productHandle) {
  // TH 5/29/26 - Scope variant/qty/button resolution to the FIRING form, not document-global.
  // Multiple product forms can share a page (e.g. rid-featured-product on page templates);
  // global selectors returned the first form's values and added the wrong variant. Fall back
  // to document-global when the firing form can't be resolved so single-form PDPs are unaffected.
  const atcButton = event.target.closest("[data-product-add-to-cart-button]") || event.target;
  // TH 9/15/26 - Sticky ATC sits outside .product-form and links to it by form attribute; resolve through it.
  const form =
    event.target.closest(".product-form") ||
    (atcButton.form ? atcButton.form.closest(".product-form") : null);
  setAddToCartButtonState(true, atcButton);
  if (productHandle == "boundless-bandana") {
    try {
      const selectedBuyOption = form.getAttribute("data-selected-buy-option") || '1';
      if (!selectedBuyOption) throw new Error("Please select a buy option");
      // Get cart count for bundle ID
      const cartResult = await fetch(`${window.themeVariables.routes.cartUrl}.js`);
      const cart = await cartResult.json();
      let bundleCount = 0;
      if (cart && cart.items && Array.isArray(cart.items)) {
        bundleCount = cart.items.filter((item) => item.handle === "boundless-bandana").length;
      }
      let itemsToAdd = [];
      if (selectedBuyOption === "1") {
        const variantIdElement = (form || document).querySelector("input[name='id']");
        const variantId = variantIdElement ? variantIdElement.value : null;
        const quantityElement = (form || document).querySelector("input[name='quantity']");
        const quantity = quantityElement ? quantityElement.value || 1 : 1;
        bundleCount++;
        itemsToAdd.push({
          quantity: quantity,
          id: variantId,
          properties: {
            "_bandana-bundle-id": String(bundleCount),
            ...(preorderDate ? { "_preorder-date": preorderDate } : {}),
          },
        });
      } else {
        const selectedVariantIds = [];
        const variantSelectors = document.querySelectorAll(
          `.variant-selectors[data-buy-option="${selectedBuyOption}"] .variant-selector`
        );
        variantSelectors.forEach((selector) => {
          const variantId = selector.getAttribute("data-selected-variant-id");
          if (variantId) selectedVariantIds.push(variantId);
        });
        const expectedVariantCount = parseInt(selectedBuyOption);
        if (selectedVariantIds.length !== expectedVariantCount) {
          throw new Error(
            `Please select ${expectedVariantCount} bandana${expectedVariantCount > 1 ? "s" : ""}`
          );
        }
        selectedVariantIds.forEach((variantId) => {
          bundleCount++;
          itemsToAdd.push({
            quantity: 1,
            id: variantId,
            properties: {
              "_bandana-bundle-id": String(bundleCount),
              ...(preorderDate ? { "_preorder-date": preorderDate } : {}),
            },
          });
        });
      }
      for (const item of itemsToAdd) {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(item),
        });
        if (!response.ok) {
          const responseJson = await response.json();
          throw new Error(responseJson["description"] || "Failed to add item to cart");
        }
      }
      await updateCartAndNotify(true);
    } catch (error) {
      await updateCartAndNotify(false, error.message);
    } finally {
      setAddToCartButtonState(false, atcButton);
    }
  } else {
    try {
      const variantIdElement = (form || document).querySelector("input[name='id']");
      const variantId = variantIdElement ? variantIdElement.value : null;
      const quantityElement = (form || document).querySelector("input[name='quantity']");
      const quantity = quantityElement ? quantityElement.value || 1 : 1;
      const mainProperties = preorderDate ? { "_preorder-date": preorderDate } : {};

      // Keep the main product first: the variant:added dispatch below reads items[0].
      const upsellItems = collectPdpUpsellItems(form || document);

      let body;
      if (upsellItems.length > 0) {
        body = {
          items: [{ id: variantId, quantity: quantity, properties: mainProperties }, ...upsellItems],
        };
      } else {
        body = { quantity: quantity, id: variantId };
        if (preorderDate) {
          body.properties = mainProperties;
        }
      }
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const responseJson = await response.json();
      await updateCartAndNotify(response.ok, responseJson["description"] || "", responseJson);
      if (response.ok) {
        document.documentElement.dispatchEvent(
          new CustomEvent("variant:added", {
            bubbles: true,
            detail: {
              variant: responseJson.hasOwnProperty("items")
                ? responseJson["items"][0]
                : responseJson,
            },
          })
        );
      }
    } catch (error) {
      await updateCartAndNotify(false, error.message);
    } finally {
      setAddToCartButtonState(false, atcButton);
    }
  }
};

function collectPdpUpsellItems(scope) {
  const root = scope || document;
  const upsellItems = [];
  root.querySelectorAll("[data-pdp-upsell]").forEach((card) => {
    const cardCheckbox = card.querySelector("[data-pdp-upsell-checkbox]");
    const cardVariantInput = card.querySelector("[data-pdp-upsell-variant-id]");
    const cardVariantId = cardVariantInput ? cardVariantInput.value : null;
    const cardUpsellKey = card.getAttribute("data-pdp-upsell-key");
    if (cardCheckbox && cardCheckbox.checked && cardVariantId) {
      const properties = { "_pdp-upsell": cardUpsellKey || "true" };
      const upsellPreorderDate = pdpUpsellPreorderDate(card, cardVariantId);
      if (upsellPreorderDate) {
        properties["_preorder-date"] = upsellPreorderDate;
      }
      upsellItems.push({
        id: cardVariantId,
        quantity: 1,
        properties: properties,
      });
    }
  });
  return upsellItems;
}

// Card exposes "variantId:YYYY-MM-DD,..." for its preorder variants only. Keep the date raw ISO.
function pdpUpsellPreorderDate(card, variantId) {
  const dateList = card.getAttribute("data-pdp-upsell-preorder-dates") || "";
  const match = dateList.split(",").find((pair) => pair.split(":")[0].trim() === String(variantId));
  return match ? match.slice(match.indexOf(":") + 1).trim() || null : null;
}

const customIdBuilderRedirect = function (event, builderUrl) {
  event.preventDefault();
  let url = builderUrl;
  try {
    const form = event.target.closest(".product-form") || document;
    let upsellItems = collectPdpUpsellItems(form);
    if (upsellItems.length === 0 && form !== document) {
      upsellItems = collectPdpUpsellItems(document);
    }
    if (upsellItems.length > 0) {
      const ids = upsellItems.map((item) => item.id).join(",");
      url += (url.indexOf("?") === -1 ? "?" : "&") + "addon_variant_ids=" + encodeURIComponent(ids);
    }
  } catch (error) {
    console.error("[pdp-upsell] failed to append upsell to builder URL:", error);
  } finally {
    window.location.href = url;
  }
};

// Helper to set Add to Cart button state
// TH 5/29/26 - Accept the firing button so multi-form pages toggle the correct one;
// fall back to the global #AddToCart lookup for any legacy caller that omits it.
function setAddToCartButtonState(loading, button) {
  const addToCartButton = button || document.getElementById("AddToCart");
  if (!addToCartButton) return;
  if (loading) {
    addToCartButton.setAttribute("disabled", "true");
    addToCartButton.setAttribute("aria-busy", "true");
  } else {
    addToCartButton.removeAttribute("disabled");
    addToCartButton.setAttribute("aria-busy", "false");
  }
}

// Helper to update cart and dispatch events
async function updateCartAndNotify(success, errorMsg, responseJson) {
  if (success) {
    if (
      window.themeVariables.settings.cartType === "page" ||
      window.themeVariables.settings.pageType === "cart"
    ) {
      window.location.href = `${Shopify.routes.root}cart`;
      return;
    }
    // Refresh cart and dispatch events
    const cartResponse = await fetch(
      `${window.themeVariables.routes.cartUrl}.js`
    );
    const cartContent = await cartResponse.json();
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:updated", {
        bubbles: true,
        detail: { cart: cartContent },
      })
    );
    if (responseJson && responseJson["sections"]) {
      cartContent["sections"] = responseJson["sections"];
    }
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartContent,
          openMiniCart: window.themeVariables.settings.cartType === "drawer",
        },
      })
    );
    document.documentElement.dispatchEvent(
      new CustomEvent("cart-notification:show", {
        bubbles: true,
        cancelable: true,
        detail: {
          status: "success",
          error: "",
        },
      })
    );
  } else {
    showCartError(errorMsg);
  }
}

// Cart page action failures (remove, duplicate, bandana +) surface through Focal's global cart-notification banner.
// Only Shopify's shopper-facing description is shown, never the raw error message.
function showCartError(message) {
  document.documentElement.dispatchEvent(
    new CustomEvent("cart-notification:show", {
      bubbles: true,
      cancelable: true,
      detail: {
        status: "error",
        error: message || "Something went wrong. Please try again.",
      },
    })
  );
}

async function cartResponseError(response, message) {
  const body = await response.json().catch(() => ({}));
  const error = new Error(message + ": " + response.status);
  error.description = body.description;
  return error;
}

var DidProductList = class extends CustomHTMLElement {
  constructor() {
    super();
    this.productListInner = this.querySelector(".product-list__inner");
    this.productItems = Array.from(this.querySelectorAll("did-product-item"));
  }
  connectedCallback() {
    this.addEventListener("prev-next:prev", this.previous.bind(this));
    this.addEventListener("prev-next:next", this.next.bind(this));
    if (!this.hidden && this.staggerApparition) {
      this._staggerProductsApparition();
    }
  }
  get staggerApparition() {
    return this.hasAttribute("stagger-apparition");
  }
  get apparitionAnimation() {
    return (this._animation =
      this._animation ||
      new CustomAnimation(
        new ParallelEffect(
          this.productItems.map((item, index) => {
            return new CustomKeyframeEffect(
              item,
              {
                opacity: [0, 1],
                transform: [
                  `translateY(${
                    MediaFeatures.prefersReducedMotion()
                      ? 0
                      : window.innerWidth < 1e3
                      ? 35
                      : 60
                  }px)`,
                  "translateY(0)",
                ],
              },
              {
                duration: 600,
                delay: MediaFeatures.prefersReducedMotion()
                  ? 0
                  : 100 * index - Math.min(3 * index * index, 100 * index),
                easing: "ease",
              }
            );
          })
        )
      ));
  }
  // Move to previous products (if any)
  previous(event) {
    const directionFlip =
        window.themeVariables.settings.direction === "ltr" ? 1 : -1,
      columnGap = parseInt(
        getComputedStyle(this).getPropertyValue("--product-list-column-gap")
      );
    event.target.nextElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute(
      "disabled",
      this.productListInner.scrollLeft * directionFlip -
        (this.productListInner.clientWidth + columnGap) <=
        0
    );
    this.productListInner.scrollBy({
      left: -(this.productListInner.clientWidth + columnGap) * directionFlip,
      behavior: "smooth",
    });
  }
  // Move to next products (if any)
  next(event) {
    const directionFlip =
        window.themeVariables.settings.direction === "ltr" ? 1 : -1,
      columnGap = parseInt(
        getComputedStyle(this).getPropertyValue("--product-list-column-gap")
      );
    event.target.previousElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute(
      "disabled",
      this.productListInner.scrollLeft * directionFlip +
        (this.productListInner.clientWidth + columnGap) * 2 >=
        this.productListInner.scrollWidth
    );
    this.productListInner.scrollBy({
      left: (this.productListInner.clientWidth + columnGap) * directionFlip,
      behavior: "smooth",
    });
  }
  async _staggerProductsApparition() {
    this.productItems.forEach((item) => (item.style.opacity = 0));
    await this.untilVisible({
      threshold:
        this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0,
    });
    this.apparitionAnimation.play();
  }
};
__publicField(DidProductList, "observedAttributes", ["hidden"]);
window.customElements.define("did-product-list", DidProductList);

var DidProductItem = class extends CustomHTMLElement {
  connectedCallback() {
    this.primaryImageList = Array.from(
      this.querySelectorAll(".product-item__primary-image")
    );
    this.delegate.on(
      "mouseenter",
      ".product-item-meta__swatch-list .color-swatch__item",
      this._onColorSwatchHovered.bind(this),
      true
    );
    this.delegate.on(
      "mouseenter",
      ".product-item-meta__swatch-list .block-swatch__item",
      this._onColorSwatchHovered.bind(this),
      true
    );
    this.delegate.on(
      "click",
      ".product-item-meta__swatch-list .color-swatch__item",
      this._onColorSwatchChanged.bind(this)
    );
    this.delegate.on(
      "click",
      ".product-item-meta__swatch-list .block-swatch__item",
      this._onColorSwatchChanged.bind(this)
    );
  }

  async _onColorSwatchChanged(event, target) {
    let product = this;
    let variants = product.getAttribute("data-product-variants");
    try {
      variants = JSON.parse(variants);
    } catch (e) {
      console.error(e);
      return;
    }
    let selectedValues = {};

    Array.from(this.querySelectorAll(".swatch-group-wrapper")).forEach(
      (swatchGroup) => {
        let count = 1;
        if (
          swatchGroup.getAttribute("data-option-name") ===
          target.getAttribute("data-option-name")
        ) {
          swatchGroup.setAttribute(
            "data-selected-value",
            target.getAttribute("value")
          );

          Array.from(
            swatchGroup.querySelectorAll(".color-swatch__item")
          ).forEach((swatch) => {
            swatch.classList.remove("is-selected");
          });
          target.classList.add("is-selected");
        }
        selectedValues[swatchGroup.getAttribute("data-option-name")] =
          swatchGroup.getAttribute("data-selected-value") || "";
        count++;
      }
    );
    let matchingVariant = null;

    matchingVariant = variants.find(function (variant) {
      return (
        variant.option1 === selectedValues[Object.keys(selectedValues)[0]] &&
        variant.option2 === selectedValues[Object.keys(selectedValues)[1]] &&
        variant.option3 === selectedValues[Object.keys(selectedValues)[2]]
      );
    });

    if (!matchingVariant) {
      matchingVariant = variants.find(function (variant) {
        return (
          variant.option1 === selectedValues[Object.keys(selectedValues)[0]] &&
          variant.option2 === selectedValues[Object.keys(selectedValues)[1]]
        );
      });
    }

    if (!matchingVariant) {
      matchingVariant = variants.find(function (variant) {
        return (
          variant.option1 === selectedValues[Object.keys(selectedValues)[0]]
        );
      });
    }

    if (!matchingVariant) {
      matchingVariant = variants[0];
    }

    let matchingVariantId = matchingVariant
      ? matchingVariant.id
      : target.getAttribute("data-variant-id");

    Array.from(this.querySelectorAll(`[href*="/products"]`)).forEach((link) => {
      let url;
      if (link.tagName === "A") {
        url = new URL(link.href);
      } else {
        url = new URL(
          link.getAttribute("href"),
          `https://${window.themeVariables.routes.host}`
        );
      }

      url.searchParams.set("variant", matchingVariantId);
      link.setAttribute("href", url.toString());
    });
    if (target.hasAttribute("data-upsell-item")) {
      updateUpsellInfoWithProductAndVariantId(this.id, matchingVariantId);
    }
    if (target.hasAttribute("data-variant-featured-media")) {
      const newImage = this.primaryImageList.find((image) => {
        const variantId = image.getAttribute("data-variant-id");

        return variantId === matchingVariantId.toString();
      });
      newImage.setAttribute("loading", "eager");
      const onImageLoaded = newImage.complete
        ? Promise.resolve()
        : new Promise((resolve) => (newImage.onload = resolve));
      await onImageLoaded;
      newImage.removeAttribute("hidden");
      let properties = {};
      if (
        Array.from(newImage.parentElement.classList).some((item) =>
          [
            "aspect-ratio--short",
            "aspect-ratio--tall",
            "aspect-ratio--square",
          ].includes(item)
        )
      ) {
        properties = [
          {
            clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
            transform: "translate(calc(-50% - 20px), -50%)",
            zIndex: 1,
            offset: 0,
          },
          {
            clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
            transform: "translate(calc(-50% - 20px), -50%)",
            zIndex: 1,
            offset: 0.3,
          },
          {
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
            transform: "translate(-50%, -50%)",
            zIndex: 1,
            offset: 1,
          },
        ];
      } else {
        properties = [
          {
            clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
            transform: "translateX(-20px)",
            zIndex: 1,
            offset: 0,
          },
          {
            clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
            transform: "translateX(-20px)",
            zIndex: 1,
            offset: 0.3,
          },
          {
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
            transform: "translateX(0px)",
            zIndex: 1,
            offset: 1,
          },
        ];
      }
      await newImage.animate(properties, {
        duration: 500,
        easing: "ease-in-out",
      }).finished;
      this.primaryImageList
        .filter(
          (image) =>
            image.classList.contains("product-item__primary-image") &&
            image !== newImage
        )
        .forEach((image) => image.setAttribute("hidden", ""));
    }
  }
  _onColorSwatchHovered(event, target) {
    if (target.hasAttribute("data-variant-featured-media")) {
      const newImage = this.primaryImageList.find(
        (image) =>
          image.getAttribute("data-media-id") ===
          target.getAttribute("data-variant-featured-media")
      );
      if (newImage) {
        newImage.setAttribute("loading", "eager");
      }
    }
  }
};
window.customElements.define("did-product-item", DidProductItem);

function smoothScrollTo(event, targetId) {
  event.preventDefault();
  const targetElement = document.getElementById(targetId);
  if (targetElement) {
    targetElement.scrollIntoView({ behavior: "smooth" });
  }
}


// Verbatim port of ROAD iD's assets/rid-theme.js video infrastructure. Keep in sync: diff against that repo rather than editing freely.
// aria-pressed is the sole carrier of state; the name stays fixed or the two contradict each
// other. The glyph swap keys off aria-pressed in did-theme.css.
function ridSetToggleState(toggle, isPaused) {
  toggle.setAttribute("aria-pressed", isPaused ? "true" : "false");
}

// js/custom-element/ui/rid-native-video.js
var RidNativeVideo = class extends HTMLElement {
  constructor() {
    super();
    this.hasLoaded = false;
    if (this.autoPlay) {
      // Never started, and never injected: pausing rejects the play promise into
      // _handleAutoplayFailure, and injecting costs metadata plus a 100px poster for nothing.
      if (this.querySelector("[data-rid-preview-toggle]") && window.MediaFeatures && window.MediaFeatures.prefersReducedMotion()) {
        this._revealPoster();
      } else {
        this.play();
      }
    } else {
      this.addEventListener("click", this._playFromUser.bind(this), { once: true });
    }
  }
  get autoPlay() {
    return this.hasAttribute("autoplay");
  }
  _playFromUser() {
    this._userActivated = true;
    this.play();
  }
  play() {
    if (!this.hasLoaded) {
      this._replaceContent();
    }
    this.querySelector("video")
      .play()
      .then(() => {
        var poster = this.querySelector(".video-wrapper__poster");
        if (poster) {
          poster.style.display = "none";
        }
        this._showPauseControl(true);
        // Outside the poster branch: the click path wipes the poster, so gating on it mutes this.
        if (this._userActivated) {
          this._announceState("Video is now playing");
        }
      })
      .catch((error) => {
        console.warn("Autoplay blocked, falling back", error);
        this._handleAutoplayFailure();
      });
  }
  pause() {
    if (this.hasLoaded) {
      this.querySelector("video").pause();
    }
  }
  _handleAutoplayFailure() {
    if (this._showHideEnabledDisabledAutoplaySections()) {
      return;
    }
    // Or the browser retries autoplay behind the poster revealed below.
    this.querySelector("video")?.removeAttribute("autoplay");
    this._revealPoster();
    // For hosts whose start control lives outside them, e.g. a slideshow slide's play button.
    this.dispatchEvent(new CustomEvent("video:autoplay-failed", { bubbles: true }));
  }

  // No focus() in here: both callers run at upgrade time with no user action behind them.
  _revealPoster() {
    var poster = this.querySelector(".video-wrapper__poster");
    // Ahead of the pause control: autoplay-off hosts wiped the poster while a teaser loop runs.
    if (!poster) {
      return;
    }
    poster.style.display = "";
    this._showPauseControl(false);
    var playButton = poster.querySelector(".video-wrapper__play-button");
    (playButton || poster).addEventListener("click", this._playFromUser.bind(this), { once: true });
  }

  // Hidden while nothing plays: the name is fixed at "Pause video", so neither aria-pressed
  // value is true. style.display, not [hidden]: did-theme.css sets display: flex on it.
  _showPauseControl(isVisible) {
    var toggle = this.querySelector("[data-rid-preview-toggle]");
    if (!toggle) {
      return;
    }
    toggle.style.display = isVisible ? "" : "none";
    if (isVisible) {
      ridSetToggleState(toggle, false);
    }
  }
  // An aria-hidden subtree is not exposed to AT, so the live region would be dead markup.
  _announceState(message) {
    if (this.closest('[aria-hidden="true"]')) {
      return;
    }
    var el = this.querySelector(".video-wrapper__sr-status");
    if (!el) {
      el = document.createElement("span");
      el.className = "video-wrapper__sr-status visually-hidden";
      el.setAttribute("role", "status");
      el.setAttribute("aria-live", "polite");
      this.appendChild(el);
    }
    el.textContent = message;
  }
  // Returns whether the swap landed, so the caller can fall through to the poster path.
  _showHideEnabledDisabledAutoplaySections() {
    var isMobile = window.innerWidth <= 740;
    var sectionId = this.getAttribute("data-section-id");
    if (!sectionId) return false;

    var findSections = function(pattern) {
      // An empty pattern must not emit a second dash: single-breakpoint sections
      // (rid-video-banner) render id="...-section-<id>", not "...-section--<id>".
      var suffix = (pattern ? pattern + "-" : "") + sectionId;
      return {
        enabled: document.getElementById("video-banner-autoplay-enabled-section-" + suffix),
        disabled: document.getElementById("video-banner-autoplay-disabled-section-" + suffix),
      };
    };

    var sections = findSections(isMobile ? "mobile" : "desktop");
    if (!sections.enabled || !sections.disabled) {
      sections = findSections("");
    }

    if (!sections.enabled || !sections.disabled) {
      return false;
    }

    sections.enabled.style.display = "none";
    sections.disabled.style.display = "block";
    return true;
  }

  _replaceContent() {
    var node = this.querySelector("template");
    if (!node) {
      return;
    }
    node = node.content.firstElementChild.cloneNode(true);
    var didWipe = !this.hasAttribute("autoplay");
    if (didWipe) {
      this.innerHTML = "";
    }
    this.appendChild(node);
    node.addEventListener("play", () => {
      this.dispatchEvent(new CustomEvent("video:played", { bubbles: true }));
    });
    node.addEventListener("pause", () => {
      this.dispatchEvent(new CustomEvent("video:paused", { bubbles: true }));
    });
    this.hasLoaded = true;
    // Focus only after a wipe: it took the activated button, dropping focus to <body>. Seeds the
    // live region first so it exists before text lands. Never focus into an aria-hidden subtree.
    if (didWipe && this._userActivated && !this.closest('[aria-hidden="true"]')) {
      this._announceState("");
      if (!node.hasAttribute("controls")) {
        node.setAttribute("tabindex", "-1");
      }
      node.focus();
    }
  }
};
window.customElements.define("rid-native-video", RidNativeVideo);

// js/custom-element/ui/rid-video-preview.js
// The teaser loop autoplays from markup, which no media query can override. This is its
// WCAG 2.2.2 pause mechanism and its reduced-motion fallback.
(function () {
  const setToggleState = ridSetToggleState;

  // Not .rid-video-preview: the autoplay-on branch's video is injected by _replaceContent with
  // no class of ours. Safe because <template> contents are not in the DOM.
  const previewFor = function (toggle) {
    const host = toggle.closest("rid-native-video");
    return host ? host.querySelector("video") : null;
  };

  // Capture phase is load-bearing: rid-native-video binds click-to-play on itself in the bubble
  // phase, so a bubble listener here would fire after it had already called play(). Capture runs
  // document to target, so the stopPropagation below lands before the element sees the click.
  document.addEventListener("click", function (event) {
    const toggle = event.target.closest("[data-rid-preview-toggle]");
    if (!toggle) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const preview = previewFor(toggle);
    if (!preview) {
      return;
    }

    if (preview.paused) {
      preview.play().catch(function () {});
      setToggleState(toggle, false);
    } else {
      preview.pause();
      setToggleState(toggle, true);
    }
  }, true);

  if (!window.MediaFeatures || !window.MediaFeatures.prefersReducedMotion()) {
    return;
  }

  const pausePreviews = function () {
    Array.from(document.querySelectorAll("video.rid-video-preview")).forEach(function (video) {
      video.autoplay = false;
      video.pause();
    });
    Array.from(document.querySelectorAll("[data-rid-preview-toggle]")).forEach(function (toggle) {
      setToggleState(toggle, true);
    });
  };

  pausePreviews();
  document.addEventListener("DOMContentLoaded", pausePreviews);
})();

// js/custom-element/section/rid-slideshow.js
// Slides keep the slide-show-item tag: Focal's connectedCallback queries it by name.
// Guarded on the base class; `class extends undefined` would throw at parse time.
var FocalSlideshow = window.customElements.get("slide-show");

var RidSlideshow = FocalSlideshow && class extends FocalSlideshow {
  connectedCallback() {
    super.connectedCallback();

    this.userPaused = false;
    // Both breakpoints' videos are in the DOM; re-check which is visible on crossing.
    this.breakpointQuery = window.matchMedia("(min-width: 1000px)");
    this.boundBreakpointChange = this.handleBreakpointChange.bind(this);
    this.breakpointQuery.addEventListener("change", this.boundBreakpointChange);
    this.addEventListener("video:played", this.handleVideoPlayed.bind(this));
    this.addEventListener("video:autoplay-failed", this.handleAutoplayFailed.bind(this));

    this.delegate.on("click", "[data-rid-slideshow-toggle]", this.handleToggleClick.bind(this));
    this.delegate.on("click", "[data-rid-slide-play]", this.handleSlidePlayClick.bind(this));

    this._activateWhenVisible();
  }
  // Theme editor re-renders sections on every setting change; don't leak per edit.
  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.videoObserver) {
      this.videoObserver.disconnect();
    }
    if (this.breakpointQuery && this.boundBreakpointChange) {
      this.breakpointQuery.removeEventListener("change", this.boundBreakpointChange);
    }
    this._pauseAllVideos();
  }

  handleBreakpointChange() {
    this._playVideos(this.items[this.selectedIndex]);
  }

  // is-playing is a deliberate one-way latch, not a leak: only .is-playing video is opacity 1, so
  // clearing it in _pauseVideos would blank a played slide until the next video:played, its poster
  // being hidden by then.
  handleVideoPlayed(event) {
    if (event.target && event.target.classList) {
      event.target.classList.add("is-playing");
    }
  }
  // Both the poster and the start control sit outside the host, because _replaceContent wipes
  // innerHTML on a host with no autoplay attribute. So neither is reachable by _revealPoster.
  handleAutoplayFailed(event) {
    const item = event.target.closest("slide-show-item");
    if (!item) {
      return;
    }
    const poster = event.target.parentElement?.querySelector(".rid-slideshow__poster");
    if (poster) {
      poster.hidden = false;
    }
    this._restorePlayButton(item, false);
  }
  handleToggleClick(event, target) {
    event.preventDefault();
    this.userPaused = !this.userPaused;
    ridSetToggleState(target, this.userPaused);

    if (this.userPaused) {
      this.pausePlayer();
      this._pauseAllVideos();
    } else {
      // startPlayer() is a no-op without the auto-play attribute, which the section omits when
      // rotation is off, so this cannot start a rotation the merchant disabled. No extra guard.
      this.startPlayer();
      this._playVideos(this.items[this.selectedIndex]);
    }
  }
  // Touches this slide's video only. Rotation state and the section toggle belong to the
  // slideshow, so starting a video must not move either.
  handleSlidePlayClick(event, target) {
    event.preventDefault();
    const item = target.closest("slide-show-item");
    if (!item) {
      return;
    }

    // Marks this playback as user-requested so the toggle's resume branch does not pause it.
    this._videosIn(item).filter(this._isVisible.bind(this)).forEach(function (video) {
      video.dataset.ridManualPlay = "true";
      video.play();
    });

    target.hidden = true;
  }
  // Not Focal's untilVisible(): it shares this.intersectionObserver, which the
  // shopify:block:select handler disconnects, stranding the promise.
  _activateWhenVisible() {
    if (!window.IntersectionObserver) {
      this._playVideos(this.items[this.selectedIndex]);
      return;
    }

    this.videoObserver = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        this.videoObserver.disconnect();
        this._playVideos(this.items[this.selectedIndex]);
      }
    }.bind(this), { rootMargin: "200px" });

    this.videoObserver.observe(this);
  }

  async select(index, shouldTransition = true, reverseDirection = false) {
    // Mirror Focal's bail-out first: a call it no-ops must not claim the generation.
    if (this.transitionType === "reveal" && this.isTransitioning) {
      return super.select(index, shouldTransition, reverseDirection);
    }

    const generation = (this.selectGeneration || 0) + 1;
    this.selectGeneration = generation;

    this._pauseVideos(this.items[this.selectedIndex]);

    await super.select(index, shouldTransition, reverseDirection);

    if (generation !== this.selectGeneration) {
      return;
    }
    this._playVideos(this.items[this.selectedIndex]);
  }

  _videosIn(item) {
    return item ? Array.from(item.querySelectorAll("rid-native-video")) : [];
  }
  _isVisible(video) {
    return !!video.parentElement && getComputedStyle(video.parentElement).display !== "none";
  }
  _playableVideos(item) {
    if (this.userPaused) {
      return [];
    }

    const autoStartAllowed = !window.MediaFeatures.prefersReducedMotion();

    return this._videosIn(item).filter(function (video) {
      if (!this._isVisible(video)) {
        return false;
      }
      // User-initiated, so neither reduced motion nor video_autoplay: false may stop it.
      if (video.dataset.ridManualPlay === "true") {
        return true;
      }
      return autoStartAllowed && video.getAttribute("data-video-autoplay") !== "false";
    }.bind(this));
  }

  _playVideos(item) {
    const playable = this._playableVideos(item);

    this._videosIn(item).forEach(function (video) {
      if (playable.indexOf(video) === -1) {
        video.pause();
      } else {
        video.play();
      }
    });

    // Reduced motion (and autoplay off) declines before play() is ever called, so no promise
    // rejects and video:autoplay-failed cannot reveal the poster. Do it for the declined hosts.
    if (playable.length === 0) {
      this._videosIn(item).forEach(function (video) {
        const poster = video.parentElement?.querySelector(".rid-slideshow__poster");
        if (poster) {
          poster.hidden = false;
        }
      });
    }

    // Or an autoplay-off slide stays paused with its only control hidden and no way back.
    this._restorePlayButton(item, playable.length > 0);
  }

  _restorePlayButton(item, isPlaying) {
    if (!item) {
      return;
    }
    const button = item.querySelector("[data-rid-slide-play]");
    if (button) {
      button.hidden = isPlaying;
    }
  }

  // Leaving the slide ends the manual play so video_autoplay: false applies again on return.
  // The toggle's pause branch keeps the mark deliberately.
  _pauseVideos(item) {
    const videos = this._videosIn(item);
    videos.forEach(function (video) {
      video.pause();
      delete video.dataset.ridManualPlay;
    });
    // Only a slide that never autoplays needs its control back. Restoring unconditionally made
    // an autoplay-on slide flash a play button every time rotation left it.
    const needsControl = videos.some(function (video) {
      return video.getAttribute("data-video-autoplay") === "false";
    });
    this._restorePlayButton(item, needsControl === false);
  }
  // A video can outlive its slide if a transition was interrupted.
  _pauseAllVideos() {
    Array.from(this.querySelectorAll("rid-native-video")).forEach(function (video) {
      video.pause();
    });
  }
};

if (RidSlideshow) {
  window.customElements.define("rid-slideshow", RidSlideshow);
} else {
  console.error("rid-slideshow: slide-show base class missing, video slides disabled");
}

// js/custom-element/section/rid-multi-row-media.js
// Not window.MediaFeatures alone: a miss there would read as "motion is fine", which is the
// unsafe direction for a gate that decides whether to autoplay.
function ridPrefersReducedMotion() {
  if (window.MediaFeatures) {
    return window.MediaFeatures.prefersReducedMotion();
  }
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

// Autoplay is a markup attribute and the browser owns scheduling, including offscreen rows.
var RidMultiRowMedia = class extends HTMLElement {
  connectedCallback() {
    if (this.hasSetUp) {
      return;
    }
    this.hasSetUp = true;
    this._setUp();
  }

  _setUp() {
    this.video = this.querySelector("video");
    if (!this.video) {
      return;
    }

    // Native controls are the JS-off pause mechanism. Both our own controls ship hidden for the
    // same reason, so nothing dead is exposed when this element never upgrades.
    this.video.removeAttribute("controls");

    this.playButton = this.querySelector("[data-rid-multi-row-play]");
    this.toggle = this.querySelector("[data-rid-multi-row-toggle]");
    this.startedFromUser = false;

    // video_tag emits the fallback img with no alt and derives aria-label from the Shopify media
    // alt, which the block setting has to be able to override.
    var alt = this.dataset.videoAlt;
    if (alt) {
      var fallbackImage = this.video.querySelector("img");
      if (fallbackImage) {
        fallbackImage.alt = alt;
      }
      this.video.setAttribute("aria-label", alt);
    }

    this.video.addEventListener("play", this._handlePlay.bind(this));
    this.video.addEventListener("pause", this._handlePause.bind(this));
    // suspend, not canplaythrough: a refused autoplay honouring preload="metadata" stalls at
    // HAVE_METADATA and never fires canplaythrough. suspend is the only signal that path emits.
    this.video.addEventListener("suspend", this._syncRefusedState.bind(this), { once: true });
    this.video.addEventListener("canplaythrough", this._syncRefusedState.bind(this), { once: true });

    if (this.playButton) {
      this.playButton.addEventListener("click", this._startFromUser.bind(this));
    }
    if (this.toggle) {
      this.toggle.addEventListener("click", this._handleToggle.bind(this));
    }

    if (this.video.autoplay && ridPrefersReducedMotion()) {
      this.video.removeAttribute("autoplay");
      this.video.pause();
    }

    if (this.video.autoplay && this.toggle) {
      this.toggle.hidden = false;
    } else if (this.playButton) {
      this.playButton.hidden = false;
    }

    if (this.video.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA) {
      this._syncRefusedState();
    }
  }

  _syncRefusedState() {
    if (this.hasPlayed || !this.toggle || !this.video.autoplay || !this.video.paused) {
      return;
    }
    this.toggle.hidden = false;
    ridSetToggleState(this.toggle, true);
  }

  // Live paused state, not aria-pressed: a refused autoplay must still start on the first click.
  _handleToggle() {
    if (this.video.paused) {
      this.video.play().catch(function () {});
    } else {
      this.video.pause();
    }
  }

  _startFromUser() {
    this.startedFromUser = true;
    var promise = this.video.play();
    if (promise) {
      promise.catch(function () {
        this.startedFromUser = false;
      }.bind(this));
    }
  }

  _handlePlay() {
    this.hasPlayed = true;
    if (this.playButton) {
      this.playButton.hidden = true;
    }
    if (this.toggle) {
      this.toggle.hidden = false;
      ridSetToggleState(this.toggle, false);
      if (this.startedFromUser) {
        this.startedFromUser = false;
        this.toggle.focus();
      }
    }
  }

  _handlePause() {
    if (this.toggle) {
      ridSetToggleState(this.toggle, true);
    }
  }
};
window.customElements.define("rid-multi-row-media", RidMultiRowMedia);

var RidProductList = class extends CustomHTMLElement {
  constructor() {
    super();
    this.productListInner = this.querySelector(".product-list__inner");
    this.productItems = Array.from(this.querySelectorAll("rid-product-item"));
  }
  connectedCallback() {
    this.addEventListener("prev-next:prev", this.previous.bind(this));
    this.addEventListener("prev-next:next", this.next.bind(this));
    if (!this.hidden && this.staggerApparition) {
      this._staggerProductsApparition();
    }
  }

  attributeChangedCallback(name) {
    if (name === "hidden") {
      if (this.staggerApparition && !this.hidden) {
        this._staggerProductsApparition();
      }
    }
  }
  get staggerApparition() {
    return this.hasAttribute("stagger-apparition");
  }
  get apparitionAnimation() {
    return (this._animation =
      this._animation ||
      new CustomAnimation(
        new ParallelEffect(
          this.productItems.map((item, index) => {
            return new CustomKeyframeEffect(
              item,
              {
                opacity: [0, 1],
                transform: [
                  `translateY(${
                    MediaFeatures.prefersReducedMotion()
                      ? 0
                      : window.innerWidth < 1e3
                      ? 35
                      : 60
                  }px)`,
                  "translateY(0)",
                ],
              },
              {
                duration: 600,
                delay: MediaFeatures.prefersReducedMotion()
                  ? 0
                  : 100 * index - Math.min(3 * index * index, 100 * index),
                easing: "ease",
              }
            );
          })
        )
      ));
  }

  previous(event) {
    const directionFlip =
        window.themeVariables.settings.direction === "ltr" ? 1 : -1,
      columnGap = parseInt(
        getComputedStyle(this).getPropertyValue("--product-list-column-gap")
      );
    event.target.nextElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute(
      "disabled",
      this.productListInner.scrollLeft * directionFlip -
        (this.productListInner.clientWidth + columnGap) <=
        0
    );
    this.productListInner.scrollBy({
      left: -(this.productListInner.clientWidth + columnGap) * directionFlip,
      behavior: "smooth",
    });
  }

  next(event) {
    const directionFlip =
        window.themeVariables.settings.direction === "ltr" ? 1 : -1,
      columnGap = parseInt(
        getComputedStyle(this).getPropertyValue("--product-list-column-gap")
      );
    event.target.previousElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute(
      "disabled",
      this.productListInner.scrollLeft * directionFlip +
        (this.productListInner.clientWidth + columnGap) * 2 >=
        this.productListInner.scrollWidth
    );
    this.productListInner.scrollBy({
      left: (this.productListInner.clientWidth + columnGap) * directionFlip,
      behavior: "smooth",
    });
  }
  async _staggerProductsApparition() {
    this.productItems.forEach((item) => (item.style.opacity = 0));
    await this.untilVisible({
      threshold:
        this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0,
    });
    this.apparitionAnimation.play();
  }
};
__publicField(RidProductList, "observedAttributes", ["hidden"]);
window.customElements.define("rid-product-list", RidProductList);


var RidProductItem = class extends CustomHTMLElement {
  connectedCallback() {
    this.primaryImageList = Array.from(
      this.querySelectorAll(".product-item__primary-image")
    );

    this.currentAnimation = null;

    // If CTA is configured as ATC, intercept delegated clicks on data-role="atc-button" elements
    this.delegate.on(
      'click',
      '[data-role="atc-button"]',
      (event, target) => {
        // Stop navigation from the wrapping anchor (if any)
        event.preventDefault();
        event.stopPropagation();
        this.addSelectedVariantToCart();
      }
    );

    this.delegate.on(
      "click",
      ".product-item-meta__swatch-list .color-swatch__radio",
      this._onColorSwatchChanged.bind(this)
    );
    this.delegate.on(
      "click",
      ".product-item-meta__swatch-list .block-swatch__radio",
      this._onColorSwatchChanged.bind(this)
    );

    // Initialize state based on any pre-selected swatches (e.g. from browser back navigation)
    this._initializeSwatchState();
  }

  _updateSwatchAvailability = function (
    bandVariants,
    selectedValues,
    matchingVariant,
    width = null
  ) {
    if (!bandVariants) return;
    let bandVariantsArr;
    try {
      bandVariantsArr = JSON.parse(bandVariants);
    } catch (e) {
      console.error("Failed to parse bandVariants", e);
      return;
    }

    if (width) {
      bandVariantsArr = bandVariantsArr.filter((variant) => {
        return (
          variant.option1 === width ||
          variant.option2 === width ||
          variant.option3 === width
        );
      });
      if (bandVariantsArr.length === 0) {
        console.warn("No band variants found for width:", width);
        return;
      }
    }

    const colorSwatchGroup = this.querySelector(
      '.swatch-group-wrapper[data-option-title="Color"]'
    );
    if (!colorSwatchGroup) return;

    colorSwatchGroup
      .querySelectorAll(".color-swatch__item")
      .forEach((swatch) => {
        const swatchValue = swatch.getAttribute("value");
        const swatchContainer = swatch.parentElement;
        const match = bandVariantsArr.find(
          (variant) =>
            variant.option1 === swatchValue ||
            variant.option2 === swatchValue ||
            variant.option3 === swatchValue
        );
        if (match && !match.available) {
          swatchContainer.classList.add("rid-product-item-swatch__unavailable");
        } else {
          swatchContainer.classList.remove(
            "rid-product-item-swatch__unavailable"
          );
        }
      });
  };

  async _onColorSwatchChanged(event, target) {
    let product = this;
    let variants = product.getAttribute("data-product-variants");
    let bandVariants = product.getAttribute("data-band-product-variants");
    let triggersAvailabilityCheck =
      target.getAttribute("triggers_availability_check") === "true" &&
      !!bandVariants;

    try {
      variants = JSON.parse(variants);
    } catch (e) {
      console.error(e);
      return;
    }
    let selectedValues = {};

    const swatchGroup = target.closest(".swatch-group-wrapper");

    if (swatchGroup) {
      swatchGroup.setAttribute(
        "data-selected-value",
        target.getAttribute("value")
      );

      swatchGroup
        .querySelectorAll(".color-swatch__item, .block-swatch__item")
        .forEach((swatch) => {
          swatch.classList.remove("is-selected");
        });

      target.classList.add("is-selected");
      const input = target
        .closest(".color-swatch, .block-swatch")
        ?.querySelector("input");
      if (input) {
        input.checked = true;
        input.focus();
      }
    }

    Array.from(this.querySelectorAll(".swatch-group-wrapper")).forEach(
      (swatchGroup) => {
        let count = 1;
        if (
          swatchGroup.getAttribute("data-option-name") ===
          target.getAttribute("data-option-name")
        ) {
          swatchGroup.setAttribute(
            "data-selected-value",
            target.getAttribute("value")
          );
        }
        selectedValues[swatchGroup.getAttribute("data-option-name")] =
          swatchGroup.getAttribute("data-selected-value") || "";
        count++;
      }
    );
    await this._findMatchingVariantAndSetRelated(
      target,
      selectedValues,
      variants,
      bandVariants,
      triggersAvailabilityCheck
    );
    return;
  }

  // Initialize component state based on pre-selected swatches
  _initializeSwatchState() {
    setTimeout(async () => {
      // Only run if at least one radio is checked (back-nav)
      const anyChecked = this.querySelector('input[type="radio"]:checked');
      if (!anyChecked) {
        return;
      }

      // Build selectedValues for option1/option2/option3 by inspecting swatch groups
      const selectedValues = {};
      const swatchGroups = this.querySelectorAll('.swatch-group-wrapper');

      swatchGroups.forEach((group) => {
        const optionName = group.getAttribute('data-option-name');
        if (!optionName) return;

        // Prefer a checked radio within the group
        let value = '';
        const checked = group.querySelector('input[type="radio"]:checked');
        if (checked) {
          value = checked.value || checked.getAttribute('value') || '';
        }

        // Fallback to explicit data-selected-value stored on the group
        if (!value) {
          value = group.getAttribute('data-selected-value') || '';
        }

        // Final fallback: first swatch item value
        if (!value) {
          const firstSwatchItem = group.querySelector('.color-swatch__item, .block-swatch__item');
          if (firstSwatchItem) {
            value = firstSwatchItem.getAttribute('value') || '';
          }
        }

        selectedValues[optionName] = value || '';
      });

      // Parse variants and optional band variants for resolution
      let variants;
      try {
        variants = JSON.parse(this.getAttribute('data-product-variants'));
      } catch (e) {
        console.error('Failed to parse variants', e);
        return;
      }

      let bandVariants = this.getAttribute('data-band-product-variants');
      try {
        bandVariants = bandVariants ? JSON.parse(bandVariants) : null;
      } catch (e) {
        console.error('Failed to parse band variants', e);
        bandVariants = null;
      }

      await this._findMatchingVariantAndSetRelated(
        null,
        selectedValues,
        variants,
        bandVariants,
        false
      );
    }, 100);
  }

  async _findMatchingVariantAndSetRelated(target, selectedValues, variants, bandVariants = null, triggersAvailabilityCheck = false) {

    let matchingVariant = variants.find(variant => 
      variant.option1 === selectedValues['option1'] &&
      variant.option2 === selectedValues['option2'] &&
      variant.option3 === selectedValues['option3']
    ) || variants.find(variant => 
      variant.option1 === selectedValues['option1'] &&
      variant.option2 === selectedValues['option2']
    ) || variants.find(variant => 
      variant.option1 === selectedValues['option1']
    ) || variants[0];

    if (!matchingVariant) return;


    let matchingVariantId = matchingVariant
      ? matchingVariant.id
      : target.getAttribute("data-variant-id");

    this.setAttribute('data-selected-variant-id', matchingVariantId);

    // Update sold out badges and forms
    const soldOutBadge = this.querySelector("#rid-product-item-sold-out-badge");
    const upsellQuickForm = this.querySelector(".upsell-quick-form");
    const productQuickForm = this.querySelector(".product-item__quick-form");

    if (matchingVariant.available) {
      soldOutBadge?.style.setProperty("display", "none", "important");
      upsellQuickForm?.style.setProperty("visibility", "visible", "important");
      productQuickForm?.style.setProperty("visibility", "visible", "important");
    } else {
      upsellQuickForm?.style.setProperty("visibility", "hidden", "important");
      productQuickForm?.style.setProperty("visibility", "hidden", "important");
      soldOutBadge?.style.setProperty("display", "inline-block", "important");
    }

    Array.from(this.querySelectorAll(`[href*="/products"]`)).forEach((link) => {
      let url;
      if (link.tagName === "A") {
        url = new URL(link.href);
      } else {
        url = new URL(
          link.getAttribute("href"),
          `https://${window.themeVariables.routes.host}`
        );
      }

      url.searchParams.set("variant", matchingVariantId);
      link.setAttribute("href", url.toString());
    });

    if (this.currentAnimation) {
      this.currentAnimation.cancel();
      this.currentAnimation = null;
    }

    const newImage = this.primaryImageList.find((image) => {
      const variantId = image.getAttribute("data-variant-id");
      return variantId === matchingVariantId.toString();
    });

    if (!newImage) {
      console.warn(
        "No matching image found for variant ID:",
        matchingVariantId
      );
      return;
    }

    newImage.setAttribute("loading", "eager");
    const onImageLoaded = newImage.complete
      ? Promise.resolve()
      : new Promise((resolve) => (newImage.onload = resolve));
    await onImageLoaded;
    newImage.removeAttribute("hidden");
    this.setAttribute("data-variant-image-src", newImage.src);
    let properties = {};
    if (
      Array.from(newImage.parentElement.classList).some((item) =>
        [
          "aspect-ratio--short",
          "aspect-ratio--tall",
          "aspect-ratio--square",
        ].includes(item)
      )
    ) {
      properties = [
        {
          clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
          transform: "translate(calc(-50% - 20px), -50%)",
          zIndex: 1,
          offset: 0,
        },
        {
          clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
          transform: "translate(calc(-50% - 20px), -50%)",
          zIndex: 1,
          offset: 0.3,
        },
        {
          clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
          transform: "translate(-50%, -50%)",
          zIndex: 1,
          offset: 1,
        },
      ];
    } else {
      properties = [
        {
          clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
          transform: "translateX(-20px)",
          zIndex: 1,
          offset: 0,
        },
        {
          clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
          transform: "translateX(-20px)",
          zIndex: 1,
          offset: 0.3,
        },
        {
          clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
          transform: "translateX(0px)",
          zIndex: 1,
          offset: 1,
        },
      ];
    }

    this.currentAnimation = newImage.animate(properties, {
      duration: 500,
      easing: "ease-in-out",
    });

    try {
      await this.currentAnimation.finished;
    } catch {
      // Animation was cancelled - this is expected when clicking rapidly
    }

    this.primaryImageList
      .filter(
        (image) =>
          image.classList.contains("product-item__primary-image") &&
          image !== newImage
      )
      .forEach((image) => image.setAttribute("hidden", ""));
    triggersAvailabilityCheck &&
      this._updateSwatchAvailability(
        bandVariants,
        selectedValues,
        matchingVariant,
        target.getAttribute("value")
      );
  }
  
  // Add currently selected variant to cart (used when CTA is configured as ATC)
  async addSelectedVariantToCart() {
    try {
      const ridProductItemId = this.getAttribute('id') || 'unknown';
      const variantIdAttr = this.getAttribute('data-selected-variant-id');
      let variantId = variantIdAttr || null;

      if (!variantId) {
        const visibleImage = this.primaryImageList.find(img => !img.hasAttribute('hidden')) || this.primaryImageList[0];
        variantId = visibleImage ? visibleImage.getAttribute('data-variant-id') : null;
      }

      if (!variantId) {
        console.error('RidProductItem: No selected variant id found for ATC CTA');
        return;
      }

      const body = {
        quantity: 1,
        id: Number(variantId)
      };

      // TH 12/4/25 - thanks i hate this, but it's the fix we need given bandana bundle cart transformer requirements.
      if (ridProductItemId.includes('bandana')) {
        let guid = crypto.randomUUID();
        body.properties = {
          '_bandana-bundle-id': String(guid),
        };
      }

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      
      if (!response.ok) {
        const responseJson = await response.json();
        
        document.documentElement.dispatchEvent(
          new CustomEvent("cart-notification:show", {
            bubbles: true,
            cancelable: true,
            detail: {
              status: "error",
              error: responseJson["description"] || `Failed to add item to cart.`,
            },
          })
        );
        return;
      }

      window.location.href = `/cart`;
    } catch (e) {
      console.error('RidProductItem: Error adding selected variant to cart', e);
    }
  }
};
window.customElements.define("rid-product-item", RidProductItem);

// js/custom-element/ui/rid-order-now.js
var RidOrderNow = class extends HTMLElement {
  constructor() {
    super();
    this.preorderDate = this.getAttribute("data-pre-order-date");
    this.orderNowTextData = document.getElementById("order-now-text-data");
    this.presetText = this.orderNowTextData?.getAttribute(
      "data-order-now-text"
    );
    this.init();
  }

  async init() {
    // Find both text elements - we need to handle both regular and mini-cart versions
    this.textElements = [
      this.querySelector("#order-now-snippet-text"),
      this.querySelector("#order-now-mini-cart-snippet-text"),
    ].filter(Boolean); // Remove any null elements

    if (this.textElements.length === 0) {
      console.error("No order now text elements found");
      return;
    }

    if (this.preorderDate) {
      this.handlePreorderDate();
    } else if (this.presetText) {
      this.handlePresetText();
    } else {
      await this.handleDynamicShipping();
    }
  }

  handlePreorderDate() {
    const [year, month, day] = this.preorderDate.split("-");
    const dateObj = new Date(year, month - 1, day);

    // An unusable date leaves the widget hidden rather than printing "Invalid Date".
    if (Number.isNaN(dateObj.getTime())) {
      console.error("Unparseable preorder date:", this.preorderDate);
      return;
    }

    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = dateObj.toLocaleDateString("en-US", options);

    const text = `Order <b>NOW</b> and items will ship on or before <b>${formattedDate}</b>.`;
    this.updateAllTextElements(text);

    const fastMessage = this.querySelector("#get-it-fast-message");
    if (fastMessage) {
      fastMessage.style.display = "none";
    }

    // The promo slot advertises fast shipping, which no preorder order qualifies for.
    const additionalText = this.querySelector("#additional-order-now-text");
    if (additionalText) {
      additionalText.style.display = "none";
    }

    this.reveal();
  }

  handlePresetText() {
    this.updateAllTextElements(this.presetText);
    this.reveal();
  }

  async handleDynamicShipping() {
    try {
      const response = await fetch(
        "https://dogid.com/pages/shipping_date_v2.json"
      );
      const responseJson = await response.json();
      const data = JSON.parse(responseJson.page.body_html.replace(/'/g, '"'));

      const now = new Date();
      const cutoffDateTime = new Date(data.cutoffDateTime);
      let shipsWhen;
      let expectedShipDate;

      if (now < cutoffDateTime) {
        expectedShipDate = new Date(data.preCutoffShipDate);
      } else {
        expectedShipDate = new Date(data.postCutoffShipDate);
      }

      const normalizeDate = (date) => {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
      };

      const normalizedExpectedShipDate = normalizeDate(expectedShipDate);
      const normalizedNow = normalizeDate(now);
      const dayDifference = Math.ceil(
        (normalizedExpectedShipDate - normalizedNow) / (1000 * 60 * 60 * 24)
      );

      if (dayDifference === 0) {
        shipsWhen = "today";
      } else if (dayDifference === 1) {
        shipsWhen = "tomorrow";
      } else if (dayDifference > 6) {
        shipsWhen = `in ${dayDifference} days`;
      } else {
        shipsWhen = expectedShipDate.toLocaleString("en-US", {
          weekday: "long",
        });
      }

      const timeDifferenceMs = cutoffDateTime - now;
      const remainingHours = Math.floor(timeDifferenceMs / (1000 * 60 * 60));
      const remainingMinutes = Math.floor(
        (timeDifferenceMs % (1000 * 60 * 60)) / (1000 * 60)
      );
      const isDeadlineApproaching = remainingHours < 6;

      let text =
        isDeadlineApproaching === false
          ? `Order <b>now</b> and it ships <b>${shipsWhen}!</b>`
          : remainingHours > 0 || remainingMinutes > 0
          ? `Order within <b>${
              remainingHours > 0
                ? `${remainingHours} ${remainingHours === 1 ? "hour" : "hours"}`
                : ""
            } ${
              remainingMinutes > 0
                ? `${remainingMinutes} ${
                    remainingMinutes === 1 ? "minute" : "minutes"
                  }`
                : ""
            }</b> and it ships <b>${shipsWhen}!</b>`
          : `Order now and it ships <b>${shipsWhen}!</b>`;

      if (this.orderNowTextData) {
        this.orderNowTextData.setAttribute("data-order-now-text", text);
      }

      this.updateAllTextElements(text);
      this.reveal();
    } catch (e) {
      console.error("Error fetching shipping information:", e);
    }
  }

  // Opacity alone leaves the shipping link focusable and announced, so hiding rides on
  // visibility and every early return keeps it out of the tab order.
  reveal() {
    this.style.visibility = "visible";
    this.style.opacity = "1";
  }

  updateAllTextElements(text) {
    this.textElements.forEach((element) => {
      element.innerHTML = text;
    });
  }
};

window.customElements.define("rid-order-now", RidOrderNow);


// js/custom-element/section/product/rid-product-media.js
var RidProductMedia = class extends CustomHTMLElement {
  async connectedCallback() {
    this.mainCarousel = this.querySelector("flickity-carousel");
    if (this.hasAttribute("reveal-on-scroll")) {
      this._setupVisibility();
    }
    if (this.mainCarousel.childElementCount === 1) {
      return;
    }
    this.selectedVariantMediaId = null;
    this.viewInSpaceElement = this.querySelector("[data-shopify-model3d-id]");
    this.zoomButton = this.querySelector(".product__zoom-button");
    this.product = await ProductLoader.load(
      this.getAttribute("product-handle")
    );
    const form = document.getElementById(this.getAttribute("form-id"));
    form?.addEventListener("variant:change", this._onVariantChanged.bind(this));
    this.mainCarousel.addEventListener("model:played", () =>
      this.mainCarousel.setDraggable(false)
    );
    this.mainCarousel.addEventListener("model:paused", () =>
      this.mainCarousel.setDraggable(true)
    );
    this.mainCarousel.addEventListener("video:played", () =>
      this.mainCarousel.setDraggable(false)
    );
    this.mainCarousel.addEventListener("video:paused", () =>
      this.mainCarousel.setDraggable(true)
    );
    this.mainCarousel.addEventListener(
      "flickity:ready",
      this._onFlickityReady.bind(this)
    );
    this.mainCarousel.addEventListener(
      "flickity:slide-changed",
      this._onFlickityChanged.bind(this)
    );
    this.mainCarousel.addEventListener(
      "flickity:slide-settled",
      this._onFlickitySettled.bind(this)
    );
    this._onFlickityReady();
  }
  get thumbnailsPosition() {
    return window.matchMedia(window.themeVariables.breakpoints.pocket).matches
      ? "bottom"
      : this.getAttribute("thumbnails-position");
  }
  async _setupVisibility() {
    await this.untilVisible();
    const flickityInstance = await this.mainCarousel.flickityInstance,
      image = flickityInstance
        ? flickityInstance.selectedElement.querySelector("img")
        : this.querySelector(".product__media-image-wrapper img"),
      prefersReducedMotion = MediaFeatures.prefersReducedMotion();
    await imageLoaded(image);
    const animation = new CustomAnimation(
      new ParallelEffect([
        new CustomKeyframeEffect(
          image,
          {
            opacity: [0, 1],
            transform: [`scale(${prefersReducedMotion ? 1 : 1.1})`, "scale(1)"],
          },
          { duration: 500, easing: "cubic-bezier(0.65, 0, 0.35, 1)" }
        ),
        new ParallelEffect(
          Array.from(
            this.querySelectorAll(".product__thumbnail-item:not(.is-filtered)")
          ).map((item, index) => {
            return new CustomKeyframeEffect(
              item,
              {
                opacity: [0, 1],
                transform:
                  this.thumbnailsPosition === "left"
                    ? [
                        `translateY(${prefersReducedMotion ? 0 : "40px"})`,
                        "translateY(0)",
                      ]
                    : [
                        `translateX(${prefersReducedMotion ? 0 : "50px"})`,
                        "translateX(0)",
                      ],
              },
              {
                duration: 250,
                delay: prefersReducedMotion ? 0 : 100 * index,
                easing: "cubic-bezier(0.75, 0, 0.175, 1)",
              }
            );
          })
        ),
      ])
    );
    this._hasSectionReloaded ? animation.finish() : animation.play();
  }
  async _onVariantChanged(event) {
    const variant = event.detail.variant;
    const featuredMediaId = event.detail.variant["featured_media"]
      ? event.detail.variant["featured_media"]["id"]
      : null;

    let allowedIds = [];
    if (featuredMediaId) allowedIds.push(featuredMediaId);

    const filteredMediaIds = [];
    this.product["media"].forEach((media) => {
      let matchMedia2 =
        variant["featured_media"] &&
        media["id"] === variant["featured_media"]["id"];
      if (media["alt"]?.includes("#")) {
        if (!matchMedia2) {
          const altParts = media["alt"].split("#"),
            mediaGroupParts = altParts.pop().split("_");
          this.product["options"].forEach((option) => {
            if (
              option["name"].toLowerCase() === mediaGroupParts[0].toLowerCase()
            ) {
              if (
                variant["options"][option["position"] - 1].toLowerCase() !==
                mediaGroupParts[1].trim().toLowerCase()
              ) {
                filteredMediaIds.push(media["id"]);
              }
            }
          });
        }
      }
    });

    let currentlyFilteredIds = [
      ...new Set(
        Array.from(this.querySelectorAll(".is-filtered[data-media-id]")).map(
          (item) => parseInt(item.getAttribute("data-media-id"))
        )
      ),
    ];
    if (allowedIds.length > 0) {
      const selectedMediaId = variant["featured_media"]
        ? variant["featured_media"]["id"]
        : this.product["media"]
            .map((item) => item.id)
            .filter((item) => !filteredMediaIds.includes(item))[0];
      const flickityInstance = await this.mainCarousel.flickityInstance;
      flickityInstance.destroy();
      Array.from(this.querySelectorAll("[data-media-id]")).forEach((item) => {
        if (item.hasAttribute("is-featured-media")) {
          allowedIds.includes(parseInt(item.getAttribute("data-media-id"))) ||
            allowedIds.push(parseInt(item.getAttribute("data-media-id")));
        }
        item.classList.toggle(
          "is-filtered",
          !allowedIds.includes(parseInt(item.getAttribute("data-media-id")))
        );
        item.classList.toggle(
          "is-selected",
          selectedMediaId === parseInt(item.getAttribute("data-media-id"))
        );
        item.classList.toggle(
          "is-initial-selected",
          selectedMediaId === parseInt(item.getAttribute("data-media-id"))
        );
      });
      this.mainCarousel.reload();
    } else {
      if (
        !event.detail.variant["featured_media"] ||
        this.selectedVariantMediaId ===
          event.detail.variant["featured_media"]["id"]
      ) {
        return;
      }
      this.mainCarousel.select(
        `[data-media-id="${event.detail.variant["featured_media"]["id"]}"]`
      );
    }
    this.selectedVariantMediaId = event.detail.variant["featured_media"]
      ? event.detail.variant["featured_media"]["id"]
      : null;
  }
  async _onFlickityReady() {
    const flickityInstance = await this.mainCarousel.flickityInstance;
    if (
      ["video", "external_video"].includes(
        flickityInstance.selectedElement.getAttribute("data-media-type")
      ) &&
      this.hasAttribute("autoplay-video")
    ) {
      flickityInstance.selectedElement.firstElementChild.play();
    }
  }
  async _onFlickityChanged() {
    const flickityInstance = await this.mainCarousel.flickityInstance;
    flickityInstance.cells.forEach((item) => {
      if (
        ["external_video", "video", "model"].includes(
          item.element.getAttribute("data-media-type")
        )
      ) {
        item.element.firstElementChild.pause();
      }
    });
  }
  async _onFlickitySettled() {
    const flickityInstance = await this.mainCarousel.flickityInstance,
      selectedSlide = flickityInstance.selectedElement;
    if (this.zoomButton) {
      this.zoomButton.hidden =
        selectedSlide.getAttribute("data-media-type") !== "image";
    }
    if (this.viewInSpaceElement) {
      this.viewInSpaceElement.setAttribute(
        "data-shopify-model3d-id",
        this.viewInSpaceElement.getAttribute("data-shopify-model3d-default-id")
      );
    }
    switch (selectedSlide.getAttribute("data-media-type")) {
      case "model":
        this.viewInSpaceElement.setAttribute(
          "data-shopify-model3d-id",
          selectedSlide.getAttribute("data-media-id")
        );
        selectedSlide.firstElementChild.play();
        break;
      case "external_video":
      case "video":
        if (this.hasAttribute("autoplay-video")) {
          selectedSlide.firstElementChild.play();
        }
        break;
    }
  }
};
window.customElements.define("rid-product-media", RidProductMedia);

// js/custom-element/section/discount/notification.js
var DiscountNotification = class extends CustomHTMLElement {
    connectedCallback() {

      document.addEventListener("discount-notification:show", this._onShow.bind(this));
  
      this.delegate.on("click", '[data-action="close"]', (event) => {
        event.stopPropagation();
        this.hidden = true;
      });
  
      this.addEventListener("mouseenter", this.stopTimer.bind(this));
      this.addEventListener("mouseleave", this.startTimer.bind(this));
      window.addEventListener("pagehide", () => (this.hidden = true));
    }
  
    set hidden(value) {
      if (!value) {
        this.startTimer();
      } else {
        this.stopTimer();
      }
      this.toggleAttribute("hidden", value);
    }
  
    get isInsideDrawer() {
      return this.classList.contains("discount-notification--drawer");
    }
  
    stopTimer() {
      clearTimeout(this._timeout);
    }
  
    startTimer() {
      this._timeout = setTimeout(() => (this.hidden = true), 3000);
    }
  
    _onShow(event) {
  
      if (this.isInsideDrawer && !this.closest(".drawer")?.open) {
        console.warn("Drawer is closed. Notification not displayed.");
        return;
      }
  
      event.stopPropagation();
  
      let closeButtonHtml = "";
      if (!this.isInsideDrawer) {
        closeButtonHtml = `
          <button class="discount-notification__close tap-area" data-action="close" style="right: 24px !important;">
            <span class="visually-hidden">${window.themeVariables.strings.accessibilityClose}</span>
            <svg focusable="false" width="14" height="14" class="icon icon--close icon--inline" viewBox="0 0 14 14">
              <path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2" fill="none"></path>
            </svg>
          </button>
        `;
      }
  
      this.innerHTML = event.detail.status === "success"
        ? `<div class="discount-notification__wrapper heading heading--small">Success! Discount applied. ${closeButtonHtml}</div>`
        : `<div class="discount-notification__wrapper discount-notification--error heading heading--small">Error: ${event.detail.error} ${closeButtonHtml}</div>`;
  
      this.hidden = false;
    }
  
    showNotification(status = "success", error = "") {
      this._onShow({ detail: { status, error } });
    }
  };
  
  window.customElements.define("discount-notification", DiscountNotification);

var DidFreeGiftFab = class extends CustomHTMLElement {
  connectedCallback() {
    this._variantId = parseInt(this.getAttribute('data-free-variant-id'), 10);
    this._productId = parseInt(this.getAttribute('data-free-product-id'), 10);
    this._qualifyingIds = (this.getAttribute('data-qualifying-ids') || '')
      .split(',')
      .map(function(id) { return parseInt(id.trim(), 10); })
      .filter(function(id) { return !isNaN(id); });
    this._delta = parseInt(this.getAttribute('data-delta'), 10) || 0;
    this._productTitle = this.getAttribute('data-product-title') || '';

    this._boundOnCartUpdated = this._onCartUpdated.bind(this);
    this._boundOnClickAdd = this._onClickAdd.bind(this);
    this._boundOnClickDismiss = this._onClickDismiss.bind(this);
    document.documentElement.addEventListener('cart:updated', this._boundOnCartUpdated);
    this.querySelector('[data-fab-btn]').addEventListener('click', this._boundOnClickAdd);
    const dismissBtn = this.querySelector('[data-fab-dismiss]');
    if (dismissBtn) dismissBtn.addEventListener('click', this._boundOnClickDismiss);

    if (this._isDeclined()) this._hide();
  }

  disconnectedCallback() {
    document.documentElement.removeEventListener('cart:updated', this._boundOnCartUpdated);
    const fabBtn = this.querySelector('[data-fab-btn]');
    if (fabBtn) fabBtn.removeEventListener('click', this._boundOnClickAdd);
    const dismissBtn = this.querySelector('[data-fab-dismiss]');
    if (dismissBtn) dismissBtn.removeEventListener('click', this._boundOnClickDismiss);
  }

  _onCartUpdated(event) {
    if (!event.detail || !event.detail.cart) return;
    this._checkCart(event.detail.cart);
  }

  _checkCart(cart) {
    const items = cart.items || [];
    let qualifyingQty = 0;
    let freeGiftQty = 0;

    // Count qualifying products and free gift in the cart
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (this._qualifyingIds.indexOf(item.product_id) !== -1) qualifyingQty += item.quantity;
      if (item.product_id === this._productId) freeGiftQty += item.quantity;
    }

    this._delta = Math.max(0, qualifyingQty - freeGiftQty);

    if (this._delta > 0 && freeGiftQty === 0) {
      const label = this._delta + ' FREE ' + this._productTitle + (this._delta === 1 ? '' : 's');
      const heading = this.querySelector('[data-fab-heading]');
      if (heading) heading.textContent = label;
      this.setAttribute('aria-label', label);
      this._show();
    } else {
      this._hide();
    }
  }

  _isDeclined() {
    try { return !!sessionStorage.getItem('did-free-gift-fab-declined-' + this._variantId); } catch (e) { return false; }
  }

  _show() {
    if (this._isDeclined()) return;
    this.removeAttribute('hidden');
    this.setAttribute('aria-hidden', 'false');
  }

  _hide() {
    if (this.contains(document.activeElement)) document.activeElement.blur();
    this.setAttribute('hidden', '');
    this.setAttribute('aria-hidden', 'true');
  }

  _onClickDismiss() {
    try { sessionStorage.setItem('did-free-gift-fab-declined-' + this._variantId, '1'); } catch (e) {}
    this._hide();
  }

  _onClickAdd() {
    const btn = this.querySelector('[data-fab-btn]');
    if (!btn || btn.getAttribute('aria-busy') === 'true' || this._delta <= 0) return;

    btn.setAttribute('aria-busy', 'true');
    btn.setAttribute('disabled', '');

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: this._variantId, quantity: this._delta })
    })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(json) {
            throw new Error(json.description || 'Failed to add to cart.');
          });
        }
        if (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart') {
          window.location.reload();
          return;
        }
        this._hide();
        return fetch(window.Shopify.routes.root + 'cart.js').then(function(r) { return r.json(); });
      }.bind(this))
      .then(function(cartData) {
        if (!cartData) return;
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cartData }
        }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cart: cartData, openMiniCart: window.themeVariables.settings.cartType === 'drawer' }
        }));
      })
      .catch(function(error) {
        console.error('DidFreeGiftFab:', error.message);
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(function(r) { return r.json(); })
          .then(this._checkCart.bind(this))
          .catch(function(e) { console.warn('DidFreeGiftFab: cart re-fetch failed', e); });
      }.bind(this))
      .finally(function() {
        btn.removeAttribute('disabled');
        btn.setAttribute('aria-busy', 'false');
      });
  }
};

window.customElements.define('did-free-gift-fab', DidFreeGiftFab);

// ------------------------------------------------------------------
// RID FREE SHIPPING BAR
// ------------------------------------------------------------------
// TH 5/26/26 - Replaces Focal's <free-shipping-bar> on our cart surfaces.
// The threshold is stored in shop currency (data-shop-threshold-cents); we convert it to the
// buyer's presentment currency via Shopify.currency.rate so the bar matches what checkout enforces.
// Liquid renders an initial shop-currency state; we only correct it on load when rate !== 1, so
// shop-currency (e.g. USD) buyers keep the pristine Liquid render with no flash. Owns both the
// --progress width and the "spend X more" text (Focal's element only did progress), and uses
// Intl.NumberFormat for the remaining amount because formatMoney() only knows the shop money format.
var RidFreeShippingBar = class extends HTMLElement {
  connectedCallback() {
    this._boundOnCartUpdated = this._onCartUpdated.bind(this);
    document.documentElement.addEventListener('cart:updated', this._boundOnCartUpdated);
    if (this._rate() !== 1) {
      this._render(this._seededTotalCents());
    }
  }

  disconnectedCallback() {
    document.documentElement.removeEventListener('cart:updated', this._boundOnCartUpdated);
  }

  _rate() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) ? parseFloat(window.Shopify.currency.rate) : 1;
  }

  _presentmentThresholdCents() {
    return (parseFloat(this.getAttribute('data-shop-threshold-cents')) || 0) * this._rate();
  }

  _seededTotalCents() {
    return parseFloat(this.getAttribute('data-cart-total-cents')) || 0;
  }

  _onCartUpdated(event) {
    if (!event.detail || !event.detail.cart || !event.detail.cart.items) return;
    var cart = event.detail.cart;
    var shippingTotal = cart.items
      .filter(function (item) { return item.requires_shipping; })
      .reduce(function (sum, item) { return sum + item.final_line_price; }, 0);
    var cartLevelDiscount = (cart.cart_level_discount_applications || [])
      .reduce(function (sum, discount) { return sum + discount.total_allocated_amount; }, 0);
    this._render(shippingTotal - cartLevelDiscount);
  }

  _render(totalCents) {
    totalCents = Math.max(0, totalCents); // a full cart-level discount can drive this negative
    var threshold = this._presentmentThresholdCents();
    this.style.setProperty('--progress', threshold > 0 ? Math.min(totalCents / threshold, 1) : 0);

    var textEl = this.querySelector('.shipping-bar__text');
    if (!textEl) return;

    if (threshold > 0 && totalCents >= threshold) {
      textEl.textContent = this.getAttribute('data-free-text') || '';
      return;
    }

    var remaining = threshold - totalCents;
    var currencyCode = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var formatted;
    try {
      formatted = new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode }).format(remaining / 100);
    } catch (e) {
      formatted = (remaining / 100).toFixed(2);
    }
    textEl.innerHTML = (this.getAttribute('data-remaining-template') || '').replace('%%AMT%%', formatted);
  }
};

window.customElements.define('rid-free-shipping-bar', RidFreeShippingBar);

// ------------------------------------------------------------------
// MOBILE NAVIGATION - DISABLE STAGGERED APPARITION ANIMATION
// ------------------------------------------------------------------
// TH 05-21-26 - Disable MobileNavigation staggered apparition animation.
// The Focal default animates each .mobile-nav__item[data-level="1"] with translateX(-40px) to 0
// over 300ms each, staggered ~120ms apart, with the footer last (~1.4s after drawer open).
// During the translateX phase, the hit-test box is shifted off its visual position, creating
// a dead-click window where users tap visible links that don't fire. The drawer's own 600ms
// CSS slide-in remains for entrance polish; per-item stagger is removed.
// Implemented as a prototype-getter override rather than editing theme.js.
window.customElements.whenDefined('mobile-navigation').then(function() {
  var MobileNav = window.customElements.get('mobile-navigation');
  if (MobileNav) {
    Object.defineProperty(MobileNav.prototype, 'apparitionAnimation', {
      get: function() { return null; },
      configurable: true
    });
  }
});

// ------------------------------------------------------------------
// PDP UPSELL DRAWER "INCLUDE" CTA
// ------------------------------------------------------------------
document.addEventListener('click', function (event) {
  var btn = event.target.closest('.js-did-upsell-drawer-cta');
  if (!btn) return;
  var checkbox = document.getElementById(btn.dataset.didUpsellCheckboxId);
  if (checkbox && !checkbox.checked) {
    checkbox.checked = true;
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));
  }
  var drawer = btn.closest('drawer-content');
  if (drawer) drawer.open = false;
});